export default __webpack_public_path__ + "static/media/0396_IMG4200.3db2c058.jpg";